import React, { useState } from 'react'
import RejectModal from './modal/RejectModal';
import * as Icon from "react-bootstrap-icons";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const RejectButton = ({ visitId, refreshData }) => {
    const userData = useSelector(state => state.loginData.userData);
    const navigate = useNavigate();

    const [showModal, setShowModal] = useState(false);
    const [rejectReason, setRejectReason] = useState('');
    const [error, setError] = useState('');
    const [loader, setLoader] = useState(false);

    // Function to handle approve/reject actions
    const handleApproveReject = async (status) => {
        setLoader(true);
        await fetch(process.env.REACT_APP_BASE_URL + '/billDistribution/rejectVisitOrImage', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                visit_id: visitId?.visit_id,
                status: status,
                rejectCategory: "Bill",
                rejectType: userData.usertype_keyname[0],
                rejectReason: status === 'Rejected' ? rejectReason : '',
                statusChangePrsnId: userData?.userId,
                statusChangePrsnMobile: userData?.contactNo,
                statusChangePrsnName: userData?.name,
                financialYear: "",
            })
        }).then((res) => res.json()).then((response) => {
            console.log("responserejectdata", response);

            if (response.status === 200) {
                navigate('/dashboard/surveyverification');
                refreshData();
            }
        }).catch((Err) => {
            console.log("Err while getting surveys images", Err);
            setLoader(false);
        })
    }

    const handleRejectSubmit = () => {
        if (rejectReason.trim() === '') {
            setError('Please enter a rejection reason.');
            return;
        }
        handleApproveReject('Rejected');
        setShowModal(false);
        setRejectReason('');
        setError('');
    };
    return (
        <>
            <div className='d-flex justify-content-center alin-items-center'>
                <button className='rejectBtn'
                    onClick={() => setShowModal(true)} >
                    <Icon.XCircleFill className='me-2' size={12} />Reject
                </button>

            </div >
            <RejectModal
                show={showModal}
                toggle={() => setShowModal(false)}
                onSubmit={handleRejectSubmit}
                error={error}
                rejectReason={rejectReason}
                setRejectReason={setRejectReason}
            />
        </>
    )
}

export default RejectButton